import React from "react";
import IcSuccess from "../../assets/icons/IcSuccess";
import IcError from "../../assets/icons/IcError";
import IcWarning from "../../assets/icons/IcWarning";

const InlineMessageComponent = ({ message, type }) => {
  return (
    <div className="message-container">
      {message && (
        <div
          className={`${
            type === "error"
              ? "error-message"
              : type === "success"
              ? "success-message"
              : "warning-message"
          }`}
        >
          <>
            {type === "success" ? (
              <IcSuccess />
            ) : type === "error" ? (
              <IcError />
            ) : (
              <IcWarning />
            )}
          </>
          {message}
        </div>
      )}
    </div>
  );
};

export default InlineMessageComponent;
